/**
 * Antiriciclaggio — coreBOS `evAntiMoneyLaundering` (84x) on evo-gdpr.evolutivo.it.
 * Harvested from evo-mcp-limitless@origin/evo-policies by scripts/harvest/gen_descriptors.py.
 * Frameworks: aml. Type sources per field: docs/harvest-report.md.
 * Regenerate instead of hand-editing; hand edits belong in the generator's SPEC.
 */
export const amlVerificationDescriptor = {
    slug: 'cmp_aml_verification',
    kind: 'document',
    label: { singular: 'Antiriciclaggio', plural: 'Antiriciclaggio' },
    table: 'compliance_aml_verification',
    idStrategy: 'sha256',
    fields: [
        { name: 'subject', type: 'text', label: 'Soggetto', required: true },
        { name: 'fascicolo_numero', type: 'text', label: 'Numero Fascicolo' },
        { name: 'tipo_verifica', type: 'text', label: 'Tipo Verifica' },
        { name: 'livello_rischio', type: 'text', label: 'Livello Rischio' },
        { name: 'data_verifica', type: 'date', label: 'Data Verifica' },
        { name: 'data_valutazione_rischio', type: 'date', label: 'Data Valutazione Rischio' },
        { name: 'scadenza_prossima_verifica', type: 'date', label: 'Scadenza Prossima Verifica' },
        { name: 'stato_conservazione', type: 'text', label: 'Stato Conservazione' },
        { name: 'data_inizio_conservazione', type: 'date', label: 'Data Inizio Conservazione' },
        { name: 'data_fine_conservazione', type: 'date', label: 'Scadenza Conservazione (10 anni)' },
        { name: 'sos_effettuata', type: 'text', label: 'Segnalazione SOS' },
        { name: 'data_segnalazione_sos', type: 'date', label: 'Data Segnalazione SOS' },
        { name: 'numero_protocollo_sos', type: 'text', label: 'Numero Protocollo SOS' },
        { name: 'modulo_av1', type: 'text', label: 'Modulo AV.1 (Valutazione Rischio)' },
        { name: 'modulo_av3', type: 'text', label: 'Modulo AV.3 (Istruttoria Cliente)' },
        { name: 'modulo_av4', type: 'text', label: 'Modulo AV.4 (Dichiarazione Cliente)' },
        { name: 'description', type: 'text', label: 'Descrizione' },
        { name: 'data_predisposizione_fascicolo', type: 'date', label: 'Data predisposizione fascicolo' },
        { name: 'fattori_rischio', type: 'text', label: 'Fattori di Rischio' },
    ],
    relations: [
        { name: 'cliente_riferimento', kind: 'belongsTo', target: 'account', toEntitySpine: true },
        { name: 'assigned_user', kind: 'belongsTo', target: 'user', toEntitySpine: true },
        { name: 'documents', kind: 'hasMany', target: 'document' },
    ],
    behaviors: { ownership: true, audit: true, softDelete: true, tenantScoped: true, documents: true },
    ui: { mode: 'generated', icon: 'ReconciliationOutlined', navGroup: 'Antiriciclaggio', deadlines: [{ field: 'scadenza_prossima_verifica' }, { field: 'data_fine_conservazione' }] },
};
